module.exports = __webpack_public_path__ + "img/import.d1d08f4c.svg";